import { render, staticRenderFns } from "./ColorCard.vue?vue&type=template&id=c608be0a&lang=pug&"
import script from "./ColorCard.vue?vue&type=script&lang=ts&"
export * from "./ColorCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports